// ESM
import { faker } from '@faker-js/faker';

export function createRandomUser(): User {
  return {
    userId: faker.string.uuid(),
    username: faker.internet.userName(),
    email: faker.internet.email(),
    avatar: faker.image.avatar(),
    password: faker.internet.password(),
    birthdate: faker.date.birthdate(),
    registeredAt: faker.date.past(),
  };
}

export const fakeData = (count= 5) => faker.helpers.multiple(createRandomUser, {
  count,
});